import { Injectable } from '@angular/core';
import type { NavigationItem } from '@clean-code/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  public openMenu$ = new BehaviorSubject<boolean>(false);
  public mobileMenuToggled$ = new BehaviorSubject<boolean>(false);
  public navigationItems$ = new BehaviorSubject<NavigationItem[]>([]);

  public toggleUserMenu() {
    this.openMenu$.next(!this.openMenu$.value);
    this.mobileMenuToggled$.next(this.openMenu$.value);
  }

  public addNavigation(items: NavigationItem[]) {
    this.navigationItems$.next(items);
  }
}
